import config from '../config';

const reserved = new Set();
Object.keys(config.spreadsheet).forEach(key => reserved.add(config.spreadsheet[key]));

export default (rows) => {
    return rows.map(row => {
        return {
            researchActivities: toResearchActivities(row),
            healthCategories: toHealthCategories(row),
            other: toOtherFields(row)
        }
    });
}

function toResearchActivities(row) {
    return [
        toResearchActivity(row[config.spreadsheet.RESEARCH_ACTIVITY_1], row[config.spreadsheet.RESEARCH_ACTIVITY_1_PERCENTAGE]),
        toResearchActivity(row[config.spreadsheet.RESEARCH_ACTIVITY_2], row[config.spreadsheet.RESEARCH_ACTIVITY_2_PERCENTAGE])
    ]
}

function toResearchActivity(code, percentage) {
    return toCode(code, percentage, config.researchActivities);
}

function toHealthCategories(row) {
    return [
        toHealthCategoryCode(row[config.spreadsheet.HEALTH_CATEGORY_1], row[config.spreadsheet.HEALTH_CATEGORY_1_PERCENTAGE]),
        toHealthCategoryCode(row[config.spreadsheet.HEALTH_CATEGORY_2], row[config.spreadsheet.HEALTH_CATEGORY_2_PERCENTAGE]),
        toHealthCategoryCode(row[config.spreadsheet.HEALTH_CATEGORY_3], row[config.spreadsheet.HEALTH_CATEGORY_3_PERCENTAGE]),
        toHealthCategoryCode(row[config.spreadsheet.HEALTH_CATEGORY_4], row[config.spreadsheet.HEALTH_CATEGORY_4_PERCENTAGE]),
        toHealthCategoryCode(row[config.spreadsheet.HEALTH_CATEGORY_5], row[config.spreadsheet.HEALTH_CATEGORY_5_PERCENTAGE])
    ]
}

function toHealthCategoryCode(code, percentage) {
    return toCode(code, percentage, config.healthCategories);
}

function toCode(code, percentage, possibleValues) {
    let value = code ? parseInt(code, 10) : 0;
    if (value < 0 || value > possibleValues.length - 1) {
        value = 0;
    }
    let percentageVal = Math.round((percentage ? parseFloat(percentage) : 0) * 100);
    if (percentageVal < 0) {
        percentageVal = 0;
    } else if (percentageVal > 100) {
        percentageVal = 100;
    }
    return {
        value: value,
        label: possibleValues[value].label,
        percentage: percentageVal
    };
}

function toOtherFields(row) {
    const other = {};
    Object.keys(row).forEach(key => {
        if (!reserved.has(key)) {
            other[key] = row[key];
        }
    });
    return other;
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/mapping/importMapper.js